import { FC } from 'react';

import { UserManagementUserList } from './user-management-user-list';

interface UserManagementPageProps {
  search: string;
}

export const UserManagementPage: FC<UserManagementPageProps> = ({ search }) => {
  return <UserManagementUserList search={search} />;
};
